"use client";
import { SimpleGrid, Text } from "@chakra-ui/react";
import ProgressStatCardSkeleton from "@ui/application/progress-stat-card/src/progress-bar-skeleton";
import * as React from "react";
import {
  StatSectionWrapperProps,
  StatsSectionWrapper,
} from "./stats-section-wrapper";

export interface StatSectionSkeletonProps
  extends Omit<StatSectionWrapperProps, "children"> {
  title: string;
  subtitle: string;
  numberOfStats?: number;
  colorScheme?: string;
}
export const StatSectionSkeleton: React.FC<StatSectionSkeletonProps> = ({
  title,
  subtitle,
  colorScheme,
  numberOfStats = 4,
  knowledgeCenterSlug,
}) => {
  return (
    <StatsSectionWrapper
      {...{ title, subtitle, colorScheme, knowledgeCenterSlug }}
    >
      <Text color="white" fontSize="md" mb="20px" fontWeight="normal">
        Click on a card to learn more about each hazard and what you can do
        about it.
      </Text>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing="6">
        {Array.from(Array(numberOfStats).keys()).map((_a, i) => (
          <ProgressStatCardSkeleton
            key={title + "-" + i}
            color={colorScheme + ".500"}
            h="173px"
          />
        ))}
      </SimpleGrid>
    </StatsSectionWrapper>
  );
};
